import { FeedAuthor } from "@routes/Author/utils/types";

import { FeedArticleItems, PodcastDataType } from "./types";

/**
 * Sanitizes article data by normalizing podcast information.
 * @param data The article data to sanitize.
 * @returns {FeedArticleItems} The sanitized article data.
 */
export const sanitizeArticleData = (data: unknown): FeedArticleItems => {
  if (typeof data !== "object" || data === null) {
    return data as FeedArticleItems;
  }

  const dataObj = data as FeedArticleItems;
  const isPodcastData =
    "podcasts" in dataObj &&
    Array.isArray(dataObj.podcasts) &&
    dataObj.podcasts.length > 0;

  if (!isPodcastData) return dataObj;

  const podcastData = Array.isArray(dataObj.podcasts)
    ? dataObj.podcasts?.[0]
    : dataObj.podcasts;

  const podcastHosts =
    "podcastHosts" in dataObj ? (dataObj.podcastHosts as FeedAuthor[]) : [];

  const normalizedPodcastData: PodcastDataType = {
    ...podcastData,
    host: podcastHosts?.[0] || [],
  };

  const normalizedAuthors = dataObj.authors?.map((author) => {
    return {
      ...author,
      image: !isPodcastData ? author.image : undefined,
    };
  });

  return {
    ...dataObj,
    podcast: normalizedPodcastData || [],
    authors: normalizedAuthors || [],
  };
};
